import React from 'react';
import PropTypes from 'prop-types';

function IssueDateCell({ colSpan, dataItem, field, className, ariaColumnIndex, style }) {
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected="false"
      style={style}>
      {dataItem[field]}
      {dataItem.isRecurring && (
        <i
          className="fa-light fa-rectangle-vertical-history"
          style={{ marginLeft: '8px', color: '#666' }}
          title="Recurring Invoice"
        />
      )}
    </td>
  );
}

IssueDateCell.propTypes = {
  colSpan: PropTypes.number.isRequired,
  dataItem: PropTypes.shape({
    issueDate: PropTypes.string,
    isRecurring: PropTypes.bool
  }).isRequired,
  field: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  ariaColumnIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};

export default IssueDateCell;
